import { makeStyles } from '@mui/styles';

export const useTaskStatusLabelStyles = makeStyles({
  root: {
    width: '8rem',
    height: '1.5625rem',
    borderRadius: '0.625rem',
    color: '#fff',
    fontSize: '0.6rem',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    padding: '0.25rem 0.5rem',
  },
  completed: {
    background: '#65C687',
  },
  inProgress: {
    background: '#FFB946',
  },
  notStarted: {
    background: '#E6E6E6',
    color: '#000000CC',
  },
});
